import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private snack: MatSnackBar) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const rid = err.headers?.get('X-Request-ID') || err.error?.requestId;
        const msg =
          err.error?.message ||
          ({ 0:'Network error', 401:'Unauthorized', 403:'Forbidden', 404:'Not found', 429:'Too many requests' } as any)[err.status] ||
          'Unexpected error';
        this.snack.open(rid ? `${msg} (ref ${rid})` : msg, 'Dismiss', { duration: 6000 });
        return throwError(err);
      })
    );
  }
}
